import $ from 'jquery';
import templateContent from '../util/template_content';
import { initTooltips } from '@/js/modules/tooltips';
import { addClearDateButton } from '@/js/modules/jquery_datepicker_clear_button';
import { updateTextOnly } from '@/js/modules/update_text_only';
import { queryString } from '@/js/modules/query_params';
import {
  enableKanbanDatePicker,
  enableKanbanDraggable,
  findNoObjectKanbanColumns,
  initKanbanDatePickers,
  initKanbanDragableAndSortable,
} from '@/js/application/kanban';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';
import '@/js/modules/jquery_datepicker_defaults';

let $viewContext;
let $viewMode;
let $projectId;

const taskModalParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  searchParams.set('view_context', $viewContext);
  searchParams.set('view_mode', $viewMode);

  if ($projectId) {
    searchParams.set('project_id', $projectId);
  }

  return searchParams;
};

const openTaskModal = (taskId) => {
  const editTaskUrl = `/tasks/${taskId}/edit?${taskModalParams().toString()}`;

  window.history.replaceState(null, '', editTaskUrl);

  const trigger = document.getElementById('edit-task-trigger');
  trigger.href = editTaskUrl;
  trigger.click();
};

// assign stacking order
export const assignTasksStackingOrder = () => {
  const listTasks = document.querySelectorAll('.tasks-table-tr');
  const kanbanTasks = document.querySelectorAll('.kanban-card');
  const tasks = listTasks.length === 0 ? kanbanTasks : listTasks;

  document.querySelectorAll('.dropdown-button__kanban-more-actions').forEach((element) => {
    element.style.zIndex = tasks.length + 1;
  });

  tasks.forEach((task, index) => {
    task.style.zIndex = tasks.length - index;
  });
};

onPageLoad(() => {
  $(function () {
    // viewContext tells us the current page [project, global and template tasks]
    $viewContext = $('meta[name="view-context"]').attr('content');
    // viewMode tells us if the current view on global tasks is Grid or Kanban
    $viewMode = $('meta[name="view-mode"]').attr('content');
    $projectId = $('meta[name="project-id"]').attr('content');
    const $templateId = $('meta[name="task-template-id"]').attr('content');
    const $sort = queryString()['sort'];
    const $isMobile = document.querySelector('body').dataset.isMobile;
    let taskUrl = window.location.href;

    // taskFormSubmitted used to prevent sending multiple ajax on ENTER press
    let taskFormSubmitted = false;

    // auto save task modal attributes on value change
    const taskAutoSaveAttrs = ['title', 'due_date', 'notes', 'assignee_id', 'priority']
      .map((attr) => `.task-form #task_${attr}`)
      .join(', ');

    const $taskId = $('meta[name="task-id"]').attr('content');
    if ($taskId) {
      const search = new URLSearchParams(window.location.search);
      search.delete('task_id');
      const fullpath = search.toString();
      taskUrl = window.location.pathname;
      taskUrl = fullpath ? `${taskUrl}?${fullpath}` : taskUrl;

      openTaskModal($taskId);
    }

    // tasks row sortable
    const initSortable = (tableClass) => {
      $(`.${tableClass} tbody`).sortable({
        handle: '.drag-handle--task',
        cursor: 'move',
        tolerance: 'pointer',
        axis: 'y',
        start: (event, ui) => {
          ui.item.addClass('tasks-table-tr--drag-start');
          if (tableClass === 'tasks-table') {
            $(ui.item)
              .children('.tasks-table-tr__td')
              .each((index, td) => {
                const elementWidth = $($('.tasks-table__th')[index]).outerWidth();
                $(td).outerWidth(elementWidth);
              });
          }
          ui.placeholder
            .css({
              visibility: 'visible',
              'padding-top': '50px',
              'border-bottom': '2px solid #555',
            })
            .find(':first-child')
            .css('border-bottom-style', 'hidden');
        },
        stop: (event, ui) => {
          ui.item.removeClass('tasks-table-tr--drag-start');
          $(`.tasks-table-tr--edit-subtask[data-task-id=${ui.item.data('task-id')}]`)
            .detach()
            .insertAfter(ui.item);
          const sortOrders = {};
          let url;

          if ($viewContext === 'task_templates') {
            url = `/task_templates/${$templateId}/xhr_reorder_template_tasks`;
          } else if ($viewContext === 'projects') {
            url = `/tasks/xhr_reorder_tasks?project_id=${$projectId}`;
          } else if ($viewContext === 'tasks') {
            url = '/tasks/xhr_reorder_tasks';
          }
          const $tasks = $(`.${tableClass} .tasks-table-tr[data-task-id]`).not(
            '.tasks-table-tr--edit-subtask'
          );
          $tasks.each((index, task) => {
            if ($viewContext === 'projects' && $('.task-form').length === 0) {
              index = $tasks.length - index - 1;
            }
            const taskId = task.dataset['taskId'];
            sortOrders[taskId] = { id: taskId, sort_order: index };
          });
          $.ajax({
            url,
            type: 'PATCH',
            data: { sort_orders: sortOrders },
          }).done(() => {
            $tasks.each((index, task) => {
              $(task).attr('data-sort-order', index);
            });
            assignTasksStackingOrder();
          });
        },
      });
    };
    initSortable('tasks-table');

    // calculate progress bar for subtask completion on task modal
    const recalculateCompletionPercentage = () => {
      if ($('.progress-bar').length === 0) {
        return;
      }

      const $parent = $('.tasks-table--subtasks');
      const $subtasks = $parent.find('.tasks-table-tr--subtask');
      const subtasksCount = $subtasks.length;
      const $completedSubtasksCount = () => {
        if ($viewMode === 'grid' || $isMobile === 'true') {
          return $subtasks.filter('.tasks-table-tr--task-completed').length;
        }

        return [...$parent.find('.checkbox--task-status')].filter(({ checked }) => checked).length;
      };

      if (subtasksCount === 0) {
        $('.progress-bar').addClass('hide');
        return;
      } else {
        $('.progress-bar').removeClass('hide');
      }
      const completionPercentage = Math.round(($completedSubtasksCount() / subtasksCount) * 100);
      $('.progress-bar__label').text(`${completionPercentage}%`);
      $('.progress-bar__fill').css('width', `${completionPercentage}%`);
    };

    // save/update the task on change of task attributes on modal
    const saveTask = () => {
      const $form = $('.task-form');
      const title = $form.find('.field--task-title').val();
      if (title.trim().length === 0) {
        $form.find('.error-message--task-title').html('Task must have a title').show();
        return false;
      } else {
        $form.find('.error-message--task-title').hide();
        $form.find('.form-error--team-project').hide();
        const formUrl = $form.attr('action');
        const formData = $form.serialize();
        $.ajax({
          url: formUrl,
          method: 'PATCH',
          data: formData,
        }).fail((xhr) => {
          const { success, errors } = JSON.parse(xhr.responseText);
          if (!success && errors.project) {
            $form
              .find('.form-error--team-project')
              .html('Sorry, you do not have access to this project.')
              .show();
          }
        });
      }
    };

    // create a subtask for task
    const createSubtask = (value) => {
      const formBaseUrl = $('.task-form').attr('action');
      $.post(`${formBaseUrl}/xhr_subtasks`, { subtask: { title: value } }, (data) => {
        $('.tasks-table--subtasks > tbody:first-child').append(data);
        recalculateCompletionPercentage();
        $('.tasks-table-tr--add-subtask').hide();
        $('.tasks-table-tr--add-subtask .field--inline-subtask-title').val('');

        const taskId = $(data).data('task-id');
        const newTask = $(`[data-task-id="${taskId}"]`);
        enableSubtaskDatePicker($(newTask).find('.subtask-due-date__date-picker'));
        initTooltips($(newTask).find('.tooltip'));
        assignTasksStackingOrder();
      });
    };

    // update inline subtask
    const updateSubtask = (e) => {
      const baseRow = $(e.target).parents('.tasks-table-tr');
      baseRow.hide();
      const title = e.target.value.trim();
      $.post(baseRow.data('update-action'), { task: { title }, _method: 'PATCH' });
      $(`.tasks-table-tr--subtask[data-task-id=${baseRow.data('task-id')}]`)
        .css('display', 'table-row')
        .find('.tasks-table-tr__td-content-title')
        .text(title);
    };

    // create global and project tasks in bulk through template
    const addTemplateTasks = (e) => {
      e.preventDefault();

      const requestParams = taskModalParams();
      const taskTemplateId = e.currentTarget.dataset.taskTemplateId;

      requestParams.set('task_template_id', taskTemplateId);

      const $firstRow = $('.tasks-table-tr:first');
      const $loaderContainer = $('.tasks-table-tr--loader-container').clone();
      $firstRow.parent().prepend($loaderContainer);
      $loaderContainer.removeClass('hide');

      if ($('.content-block--blank-tasks').length > 0) {
        $('.p-button--header-add-task').removeClass('hide');
        $('.dropdown-button--task-template').removeClass('hide');

        const updateBlankTasksContainer = (className) =>
          $(`.${className}`).addClass('content-block--tasks').removeClass(className);

        if ($viewMode === 'grid' || $isMobile === 'true') {
          updateBlankTasksContainer('content-block--blank-tasks-table');
        } else {
          updateBlankTasksContainer('kanban-container--blank-tasks');
        }

        $('.content-block--blank-tasks').remove();
      }

      $.post(`/tasks/xhr_add_template_tasks?${requestParams.toString()}`, (data) => {
        const prependTasks = ($container) =>
          data['tasks_html'].map((taskHtml) => $container.prepend(taskHtml));

        if ($viewMode === 'grid' || $isMobile === 'true') {
          prependTasks($firstRow.parent());
          $loaderContainer.remove();
          initGridDatePicker();
          initTooltips($firstRow.parent().find('.tooltip'));
        } else {
          const $parent = $('.kanban-column__container').first();
          const $newTaskForm = $('.kanban-card--inline-form');
          const columnName = document.querySelector('.kanban-column-header__column-name');
          const newTotal = parseInt(columnName.dataset.count) + data['tasks_html'].length;

          prependTasks($parent);
          $parent.prepend($newTaskForm);
          columnName.dataset.count = newTotal;
          columnName.innerText = `${columnName.dataset.oldName} (${newTotal})`;
          initKanbanDatePickers();
          initKanbanDragableAndSortable();
          initTooltips($parent.find('.tooltip'));
        }
        assignTasksStackingOrder();
      });
    };

    // due date selection for task from grid view
    const initGridDatePicker = () => {
      $('.task-due-date__input').datepicker({
        beforeShow: (input, calendar) => {
          const $dueDateContainer = $(input).closest('.task-due-date');
          const $dueDatePicker = $dueDateContainer.find('.ui-datepicker');
          if (!$dueDatePicker.length) {
            $dueDateContainer.append(calendar.dpDiv);
          }
          setTimeout(() => {
            addClearDateButton(input);
            calendar.dpDiv.css({
              top: '18px',
              left: '0',
            });
            calendar.dpDiv.addClass('ui-datepicker--task');
          }, 0);
        },
        onChangeMonthYear: (_year, _month, calendar) => {
          addClearDateButton(calendar.input[0]);
        },
        onSelect(date, calendar) {
          const taskId = $(this).closest('.tasks-table-tr').data('taskId');
          const data = {
            task: { due_date: date },
            view_context: $viewContext,
            view_mode: $viewMode,
            sort: $sort,
          };

          if ($projectId) {
            data['project_id'] = $projectId;
          }

          $.ajax({
            url: `/tasks/${taskId}`,
            type: 'PATCH',
            data,
            success(response) {
              if (response.success) {
                // Update the task row with the updated data
                const $taskRow = $(`tr[data-task-id="${response.task_id}"]`);
                $taskRow.replaceWith(response.task_partial);
                // Reinitialize the datepicker after replacing the task row
                initGridDatePicker();
                initTooltips($(`tr[data-task-id="${response.task_id}"]`).find('.tooltip'));
              }
              assignTasksStackingOrder();
            },
          });
        },
      });
    };
    initGridDatePicker();

    // infinite scroll for tasks in grid mode
    const loadTasks = ({ nextPage, url }) => {
      document
        .querySelector('.content-block--tasks')
        .insertAdjacentHTML('beforeend', '<div class="tasks-table__loading">Loading...</div>');

      const requestParams = taskModalParams();

      requestParams.set('page', parseInt(nextPage));

      $.getJSON({ data: requestParams.toString(), url }).done(({ html, next_page: nextPage }) => {
        const tableScroller = document.querySelector('.tasks-table--scroller');

        document.querySelector('.tasks-table__loading').remove();
        tableScroller.dataset.nextPage = nextPage;

        html.forEach((tr) => tableScroller.insertAdjacentHTML('beforeend', tr));

        initGridDatePicker();

        initTooltips(tableScroller.querySelectorAll('.tooltip'));
        assignTasksStackingOrder();
      });
    };

    function observeTasks() {
      const tableScroller = document.querySelector('.tasks-table--scroller');
      const { dataset: { nextPage = '' } = {} } = tableScroller || {};
      const isLoading = document.querySelectorAll('.tasks-table__loading').length > 0;
      const noNextPage = () => nextPage === '' || nextPage === 'null';

      if (tableScroller === undefined || isLoading || noNextPage()) {
        return;
      }

      new IntersectionObserver((entries) => {
        entries
          .filter(({ isIntersecting }) => isIntersecting)
          .forEach(() => loadTasks({ nextPage, url: '/tasks' }));
      }).observe(tableScroller);
    }

    function isScrollbarVisible() {
      return document.documentElement.scrollHeight > document.documentElement.clientHeight;
    }

    function observeTaskEndUntilScrollEvent() {
      if (isScrollbarVisible()) {
        return; // stop the function if scroll event is present
      }

      observeTasks();
      setTimeout(observeTaskEndUntilScrollEvent, 100);
    }

    observeTaskEndUntilScrollEvent();

    $('.drag-handle--task').hover((e) => {
      $(e.target.closest('tr')).toggleClass('tasks-table-tr--drag-shadow');
    });

    // on outside click, close the filter dropdown for global tasks
    $('#tasks').on('click', (e) => {
      const $dropdown = $(e.target).closest('.filter-list__item');
      if (!$dropdown.length && $('.filter-list__item').hasClass('filter-list__item--open')) {
        $('.filter-list__item').removeClass('filter-list__item--open');
      }
    });

    const initTaskModal = (modal) => {
      $(modal)
        .find('.growable-field-container--task-title')
        .attr('data-replicated-value', $('.field--task-title').val());

      initSortable('tasks-table--subtasks');
      $('.tasks-table--subtasks .subtask-due-date__date-picker').each((_i, el) => {
        enableSubtaskDatePicker($(el));
      });
      assignTasksStackingOrder();

      taskFormSubmitted = false;
    };

    $(document).on('turbo:frame-load', '#edit_task', (e) => initTaskModal(e.target));

    // update the current task row when the task modal closes
    const refreshTaskRow = ($form) => {
      const baseUrl = $form.attr('action');

      $.ajax({
        type: 'PATCH',
        url: `${baseUrl}?${taskModalParams().toString()}`,
        data: $form.serialize(),
        dataType: 'json',
        success(response) {
          if (response.success) {
            // Update the task row with the updated data
            let $taskRow;

            if ($viewMode === 'grid' || $isMobile === 'true') {
              $taskRow = $(`tr[data-task-id="${response.task_id}"]`);
            } else {
              $taskRow = $(`.kanban-card[data-id="${response.task_id}"]`);
            }

            $taskRow.replaceWith(response.task_partial);
            initGridDatePicker();

            if ($viewMode === 'kanban' && $isMobile === 'false') {
              $taskRow = $(`.kanban-card[data-id="${response.task_id}"]`);
              enableKanbanDraggable($taskRow);
              enableKanbanDatePicker($taskRow.find('.kanban-card__date-picker'));
            }

            if ($viewMode === 'grid' || $isMobile === 'true') {
              initTooltips($(`tr[data-task-id="${response.task_id}"]`).find('.tooltip'));
            } else {
              initTooltips($(`.kanban-card[data-id="${response.task_id}"]`).find('.tooltip'));
            }

            assignTasksStackingOrder();
          }
        },
      });

      window.history.replaceState(null, '', taskUrl);
      // Reset taskFormSubmitted to false when the modal is closed
      taskFormSubmitted = false;
    };

    $(document).on('ui--twin-turbo-modal:close', (e) => {
      const $form = $(e.target).find('#edit_task .task-form');

      if ($form.length) {
        refreshTaskRow($form);
      }
    });

    // auto save the task modal attributes on value change on modal
    $(document).on('change', taskAutoSaveAttrs, saveTask);
    $(document).on('ui--search-select:change', '.task-form', saveTask);

    // recalculate progress bar on subtask deletion
    $(document).on('ajax:complete', '.delete-subtask', (e) => {
      e.target.closest('.tasks-table-tr').remove();
      recalculateCompletionPercentage();
    });

    // format datepicker date from team date format into 'MMM DD' format
    function formatTaskDate(originalDate) {
      const dateFormat = $.datepicker._defaults.dateFormat;
      const [m, d, y] = originalDate.split('/');
      const [month, day, year] =
        {
          'mm/dd/yy': [m, d, y],
          'dd/mm/yy': [d, m, y],
          'yy/mm/dd': [d, y, m],
        }[dateFormat] || [];

      return new Date(year, month - 1, day).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
      });
    }

    // enable date picker for subtasks
    const enableSubtaskDatePicker = ($item) => {
      $item.datepicker({
        onSelect: (dateText, inst) => {
          const datePicker = inst.input[0];
          const objectId = $(datePicker).closest('.tasks-table-tr--subtask').data('task-id');
          const $dueDate = $(datePicker).siblings('.subtask-due-date__date');
          const selectedDate = new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay);
          const formattedDate = formatTaskDate(dateText);
          if (selectedDate < new Date()) {
            $dueDate.addClass('subtask-due-date__date--past-due');
          } else {
            $dueDate.removeClass('subtask-due-date__date--past-due');
          }
          $dueDate
            .removeClass('hide')
            .addClass('tooltip')
            .find('.subtask-due-date__text')
            .text(formattedDate);
          $(datePicker).addClass('hide');
          $(datePicker)
            .siblings('.subtask-due-date__add-date')
            .removeClass('tooltip')
            .addClass('hide');
          $(datePicker).find('.subtask-due-date__clear-date').removeClass('hide');
          initTooltips($dueDate);
          $.post(
            `/tasks/${objectId}`,
            {
              task: { due_date: dateText },
              _method: 'PATCH',
            },
            () => {
              $dueDate.attr('data-due-date', dateText);
            }
          );
        },
      });
    };

    // Subtask has no due date. Open date picker
    $(document).on('click', '.subtask-due-date__add-date', (e) => {
      e.preventDefault();
      // Hide all currently open date pickers
      $('.subtask-due-date__date-picker').addClass('hide');

      const $target = $(e.target);
      const $el = $target.hasClass('subtask-due-date__add-date')
        ? $target
        : $target.closest('.subtask-due-date__add-date');
      $el
        .siblings('.subtask-due-date__date-picker')
        .toggleClass('hide')
        .css('top', '24px')
        .css('left', 'auto')
        .css('right', '-8px');
    });

    // Subtask has a due date. The action is to update it.
    $(document).on('click', '.subtask-due-date__date', (e) => {
      e.preventDefault();

      // Hide all currently open date pickers
      $('.subtask-due-date__date-picker').addClass('hide');

      const $target = $(e.target);

      const $el = $target.hasClass('subtask-due-date__date')
        ? $target
        : $target.closest('.subtask-due-date__date');

      $el
        .siblings('.subtask-due-date__date-picker')
        .toggleClass('hide')
        .datepicker('setDate', $el.attr('data-due-date'))
        .css('top', '24px')
        .css('left', 'auto')
        .css('right', '8px');
    });

    // Clear subtask due date
    $(document).on('click', '.subtask-due-date__clear-date', (e) => {
      const objectId = $(e.target).closest('.tasks-table-tr--subtask').data('task-id');
      const $datePicker = $(e.target).closest('.subtask-due-date__date-picker');
      const $projectDueDate = $datePicker.siblings('.subtask-due-date__date');
      const $addDateButtons = $projectDueDate.siblings('.subtask-due-date__add-date');
      $(e.target).addClass('hide');
      $datePicker.addClass('hide');
      $projectDueDate.addClass('hide').removeClass('tooltip');
      $addDateButtons.addClass('tooltip').removeClass('hide');
      initTooltips($addDateButtons);
      $.post(
        `/tasks/${objectId}`,
        {
          task: { due_date: null },
          _method: 'PATCH',
        },
        () => {
          $datePicker.datepicker('setDate', null);
          $projectDueDate.attr('data-due-date', null);
        }
      );
    });

    // Hide date pickers when clicking outside
    $('html').click((e) => {
      const kanbanSelectors =
        '.kanban-card__add-due-date, .kanban-card__date-picker, .kanban-card__date-picker *, .kanban-card__due-date, .kanban-card__due-date *';
      const subtaskSelector = '.subtask-due-date__add-date';

      const isKanbanTarget = $(e.target).is(kanbanSelectors);
      const isSubtaskTarget = $(e.target).is(subtaskSelector);
      const isDatePicker =
        typeof e.target.className === 'string' && e.target.className.includes('ui-datepicker');

      if (!isKanbanTarget && !isDatePicker) {
        $('.kanban-card__date-picker').addClass('hide');
      }

      if (!isSubtaskTarget && !isDatePicker) {
        $('.subtask-due-date__date-picker').addClass('hide');
      }
    });

    // show inline task row on Add Task button Click
    // on global page the task will be shown at top else at the bottom of the page
    // on kanban view mode, just show the inline-form kanban card
    $(document).on(
      'click',
      '.tasks-table-tr__inline-add-task, .p-button--header-add-task, .kanban-column-header__add-task',
      (e) => {
        e.preventDefault();

        if ($viewMode === 'grid' || $isMobile === 'true') {
          const $addTaskRow = $('.tasks-table-tr--add-task');
          const $tableRows = $('.tasks-table-tr');

          const insertBeforeRow =
            $(e.target).hasClass('p-button--header-add-global-task') ||
            $(e.target).hasClass('p-button--header-add-project-task')
              ? $tableRows.first()
              : $tableRows.last();

          $addTaskRow.insertBefore(insertBeforeRow);
          $addTaskRow.css('display', 'table-row');

          $('.tasks-table-tr--add-task').css('display', 'table-row');
        } else {
          // Setting the default value as "to_do" covers the case when clicking on the
          // global "Add Task" button, as it doesn't belong to a particular column.

          // Use first column if clicking global add task button, else default to 'to_do'
          let column;
          if ('column' in e.target.dataset) {
            ({ column } = e.target.dataset);
          } else {
            const firstColumn = $('.kanban-column').first();
            if (firstColumn.length) {
              column = firstColumn.attr('data-column');
            } else {
              column = 'to_do';
            }
          }

          $(`.kanban-card--inline-form[data-column='${column}']`).show();
        }

        // required to reset the height of the textarea
        $('.growable-field-container--inline-task-title').attr('data-replicated-value', '');
        $('.field--inline-task-title').val('').focus();
      }
    );

    $(document).on('click', '.p-button--add-task', (e) => {
      e.preventDefault();

      $('.content-block--blank-tasks-table').fadeIn();
      $('.content-block--blank-tasks').hide();

      if ($viewMode === 'grid' || $isMobile === 'true') {
        $('.tasks-table-tr--add-task').css('display', 'table-row');
      } else {
        $('.kanban-container').removeClass('kanban-container--blank-tasks');
        $('.kanban-card--inline-form[data-column=to_do]').show();
        $('.p-button--header-add-task').removeClass('hide');
        $('.dropdown-button--task-template').removeClass('hide');
      }

      $('.field--inline-task-title').val('').focus();
    });

    const hideInlineTaskForm = () => {
      // Reset taskFormSubmitted to false when the inline-form is closed
      taskFormSubmitted = false;
      if ($viewMode === 'grid' || $isMobile === 'true') {
        $('.tasks-table-tr--add-task').hide(250);
        $('.content-block--blank-tasks-table').hide();
        $('.content-block--blank-tasks').fadeIn();
      } else {
        $('.kanban-card--inline-form').hide();
      }
    };

    // hide inline task on ESCAPE key press
    // submit inline task on ENTER key press
    $(document).on('keydown', '.field--inline-task-title', (e) => {
      if (e.key === 'Escape') {
        hideInlineTaskForm();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (!e.shiftKey && !taskFormSubmitted) {
          $(e.target).closest('.inline-task-form').submit();
          taskFormSubmitted = true;
        }
      }
    });

    // avoid mutiple inline task/subtask submission on multiple ENTER press
    $(document).on('submit', '.inline-task-form, .task-form__add-subtask', () => {
      // Set taskFormSubmitted to true after submitting the form
      taskFormSubmitted = true;
    });

    $(document).on('submit', '.inline-task-form', (e) => {
      e.preventDefault();

      const $form = $(e.target);
      const $titleField = $form.find('.field--inline-task-title');
      const { column } = $form.data();

      if ($titleField.val().trim().length === 0) {
        hideInlineTaskForm();
        return;
      }

      const $formData = $form.serialize();

      $.post($form.attr('action'), $formData, (response) => {
        $titleField.val('');

        const $taskRow = $(response.task_row_html);

        if ($viewMode === 'grid' || $isMobile === 'true') {
          const sortOrder = $taskRow.data('sort-order');
          const $body = $('body');
          const $tasksTableBody = $('.tasks-table tbody');

          // append newly created task as last row in the tasks table
          if ($body.is('#tasks, #projects-tasks')) {
            const $loaderContainer = $tasksTableBody.find('.tasks-table-tr--loader-container');
            $taskRow.insertAfter($loaderContainer);
          } else {
            $tasksTableBody.append($taskRow);
          }

          // when we have added a first task, we need to remove the blank tasks callout
          if (sortOrder) {
            $('.p-button--header-add-task').removeClass('hide');
            $('.dropdown-button--task-template').removeClass('hide');
            $('.content-block--blank-tasks-table')
              .addClass('content-block--tasks')
              .removeClass('content-block--blank-tasks-table');
            $('.content-block--blank-tasks').remove();
          }

          hideInlineTaskForm();
          $('.tasks-table-tr--no-task').hide();
          initGridDatePicker();
          initTooltips($(`tr[data-task-id="${$taskRow.data('task-id')}"]`).find('.tooltip'));
        } else {
          hideInlineTaskForm();
          $taskRow.insertAfter(`.kanban-card--inline-form[data-column='${column}']`);
          enableKanbanDraggable($taskRow);
          enableKanbanDatePicker($taskRow.find('.kanban-card__date-picker'));
          taskFormSubmitted = false;
          $('.p-button--header-add-global-task').removeClass('hide');
          findNoObjectKanbanColumns();

          const columnName = document.querySelector(
            `.kanban-column-header__column-name[data-column="${column}"]`
          );
          const newTotal = parseInt(columnName.dataset.count) + 1;
          columnName.dataset.count = newTotal;
          columnName.innerText = `${columnName.dataset.oldName} (${newTotal})`;
          initTooltips($(`.kanban-card[data-id="${$taskRow.data('id')}"]`).find('.tooltip'));
        }
        assignTasksStackingOrder();
      });
    });

    // submit inline task form on blur or outside click of the page
    $(document).on('blur', '.field--inline-task-title', (e) => {
      if ($(e.relatedTarget).is('.field--task-title')) {
        return;
      }
      const openNewInputField = $(e.relatedTarget).is(
        '.tasks-table-tr__inline-add-task, .p-button--header-add-task'
      );

      const title = $(e.target).val();
      if (title.trim().length === 0) {
        if (!openNewInputField) {
          hideInlineTaskForm();
        }

        return;
      }

      $(e.target).parents('.inline-task-form').submit();
    });

    // show inline subtask form row on task modal
    $(document).on('click', '.task-form__add-subtask', (e) => {
      e.preventDefault();
      $('.tasks-table-tr--add-subtask').css('display', 'table-row');
      $('.tasks-table-tr--add-subtask .field--inline-subtask-title').val('').focus();
      taskFormSubmitted = false;
    });

    // create/update inline subtask on task modal
    $(document).on('keyup', '.field--inline-subtask-title', (e) => {
      if (e.key === 'Enter' && !taskFormSubmitted) {
        e.preventDefault();
        const title = e.target.value.trim();
        if (title.length === 0) {
          return;
        }

        if (e.target.closest('.tasks-table-tr--add-subtask')) {
          createSubtask(title);
          taskFormSubmitted = true;
        } else if (e.target.closest('.tasks-table-tr--edit-subtask')) {
          updateSubtask(e);
        }
      }
    });

    // create tasks on global/projects on template click
    $(document).on('click', '.add-template-tasks', addTemplateTasks);

    // create subtask
    $(document).on('blur', '.tasks-table-tr--add-subtask .field--inline-subtask-title', (e) => {
      const title = e.target.value.trim();
      if (title.length > 0) {
        createSubtask(title);
      } else {
        $('.tasks-table-tr--add-subtask').hide();
      }
    });

    // show inline text field for subtask to be updated
    $(document).on('click', '.tasks-table--subtasks .tasks-table-tr__td-content-title', (e) => {
      const baseRow = $(e.target).parents('.tasks-table-tr');
      baseRow.hide();
      $(`.tasks-table-tr--edit-subtask[data-task-id=${baseRow.data('task-id')}]`).css(
        'display',
        'table-row'
      );
      $('.field--inline-subtask-title').focus();
      taskFormSubmitted = false;
    });

    // update subtask
    $(document).on(
      'blur',
      '.tasks-table-tr--edit-subtask .field--inline-subtask-title',
      updateSubtask
    );

    // mark task/subtask as complete
    $(document).on('click', '.checkbox--task-status, .h-p-button--mark-complete', (e) => {
      if (document.body.id === 'projects-dashboard') {
        return;
      }

      const isSubtask = ($el) => $el.parents('.tasks-table--subtasks').length > 0;

      const $el = $(e.currentTarget);
      const id = e.currentTarget.dataset['taskId'];

      $.ajax({
        url: `/tasks/${id}/xhr_toggle_completed`,
        type: 'PATCH',
      }).done(() => {
        const $checkBox = $(`#task-status-${id}`);
        const $parent = $(`.tasks-table-tr[data-task-id="${id}"]`);

        if ($el.hasClass('h-p-button--mark-complete')) {
          $checkBox.prop('checked', !$checkBox.prop('checked'));
        }

        if ($viewMode === 'kanban' || $isMobile === 'true') {
          const $kanbanCard = $(`.kanban-card[data-id=${id}]`);
          const $kanbanColumn = $kanbanCard.closest('.kanban-column__container');
          const taskCompleted = $checkBox.prop('checked');
          const taskCompletedBtnText = taskCompleted ? 'Completed' : 'Mark Complete';

          // do not update counters when toggling subtasks
          if ($kanbanColumn.length) {
            // update kanban view task card styles
            $kanbanCard
              .find('.kanban-card__task-title')
              .toggleClass('kanban-card__task-title--decoration', taskCompleted);
            $kanbanCard.toggleClass('kanban-card--completed', taskCompleted);
          } else {
            // update kanban view sub-tasks styles
            $parent
              .find('.tasks-table-tr__title')
              .toggleClass('tasks-table-tr__title--decoration', taskCompleted);
            $parent.toggleClass('tasks-table-tr--task-completed', taskCompleted);
          }
          updateTextOnly(
            $el.toggleClass('h-p-button--task-completed', taskCompleted),
            taskCompletedBtnText
          );

          enableKanbanDraggable($kanbanCard);
          enableKanbanDatePicker($kanbanCard.find('.kanban-card__date-picker'));
        } else {
          const pastDueDate = $parent.data('past-due-date');

          if ($checkBox.prop('checked')) {
            $parent.find('.tasks-table-tr__title').addClass('tasks-table-tr__title--decoration');
            if (pastDueDate) {
              $parent
                .find('.task-due-date__input--past')
                .addClass('task-due-date__input--completed')
                .removeClass('task-due-date__input--past');
            }
            updateTextOnly($el.addClass('h-p-button--task-completed'), 'Completed');
            $parent.addClass('tasks-table-tr--task-completed');
            if (window.location.search.includes('completed=false')) {
              $parent.remove();
            }
          } else {
            if (pastDueDate) {
              $parent
                .find('.task-due-date__input--completed')
                .addClass('task-due-date__input--past')
                .removeClass('task-due-date__input--completed');
            }
            $parent.find('.tasks-table-tr__title').removeClass('tasks-table-tr__title--decoration');
            updateTextOnly($el.removeClass('h-p-button--task-completed'), 'Mark Complete');
            $parent.removeClass('tasks-table-tr--task-completed');
          }
        }

        if (isSubtask($el)) {
          recalculateCompletionPercentage();
        }
      });
    });

    // Open task edit modal in grid mode.
    $(document).on(
      'click',
      '.tasks-table-tr__title, .tasks-table-tr__details-icon-container',
      (e) => {
        e.preventDefault();
        openTaskModal($(e.currentTarget).closest('tr').data('task-id'));
      }
    );

    // Open task edit modal in kanban mode.
    $(document).on('click', '.kanban-card:not(.kanban-card--inline-form)', (e) => {
      const $target = $(e.target);

      if ($viewContext === undefined || $viewMode === undefined) {
        return;
      }

      if (
        $target.is('.checkbox--task-status') ||
        $target.is('.checkbox__label') ||
        $target.is('.kanban-card__due-date-container *') ||
        $target.is('.kanban-card__task-assignee-container *') ||
        $target.is('.kanban-card__task-priority-container *') ||
        $target.is('.kanban-card__avatar') ||
        $target.is('.kanban-card__task-project-name') ||
        $target.is('.kanban-card__container--inline-form') ||
        $target.is('.field--inline-task-title') ||
        $target.is('.fa-trash')
      ) {
        return;
      }

      e.preventDefault();

      openTaskModal($target.closest('.kanban-card').data('id'));
    });

    //
    // Task comments
    //

    // Toggles the disabled state of comment form buttons and shows/hides loading indicator
    const disableNewCommentSubmit = (state = true) => {
      const submitButton = document.querySelector('.task-comments__form-control--submit');

      if (!submitButton) {
        return;
      }

      submitButton.disabled = state;

      if (state) {
        submitButton.classList.add('button-loading');
      } else {
        submitButton.classList.remove('button-loading');
      }
    };

    // Clears the comment form and resets it to its initial state
    const resetNewCommentFormState = () => {
      $('#comment_body').val('');
      $('#new_comment .tiptap').addClass('resetRequest');
      $('#new_comment .task-comments__form-controls').hide();

      disableNewCommentSubmit(false);
    };

    $(document).on('submit', '.task-comments__form', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Disable the submit button to prevent multiple submissions
      disableNewCommentSubmit();

      const $form = $(e.target);
      const formData = $form.serializeArray();

      const $tiptapEditor = $('.task-comments__form .tiptap');
      const mentionedUserIds = $.map($tiptapEditor.find('[data-type="mention"]'), (el) => {
        return $(el).data('id');
      });

      formData.push({ name: 'comment[user_ids]', value: mentionedUserIds.join(',') });

      $.ajax({
        url: $('.task-comments__form').attr('action'),
        type: 'POST',
        data: formData,
        success: (data) => {
          $('.task-comments__list').prepend(data);
          resetNewCommentFormState();
        },
        error: () => {
          // Re-enable buttons on failure so user can retry
          disableNewCommentSubmit(false);
        },
      });
    });

    $(document).on('click', '.task-comments__form-control--cancel', (e) => {
      e.preventDefault();
      e.stopPropagation();

      resetNewCommentFormState();
    });

    // Task Delete Event
    $(document).on('click', '.delete-task, .task-form__delete', (e) => {
      e.preventDefault();

      const modal = templateContent(document.getElementById('task-delete-template'));
      modal.querySelector('form').action =
        `${e.currentTarget.dataset.deleteUrl}?${taskModalParams().toString()}`;
      document.body.append(modal);
    });

    $(window).scroll((e) => {
      const $this = $(e.target);
      const height = Math.floor($(document).height() - $(window).height()); // Get the height of the div
      const scroll = Math.ceil($this.scrollTop()); // Get the vertical scroll position

      const isScrolledToEnd = scroll >= height;

      if (isScrolledToEnd) {
        observeTasks();
      }

      // if  windw reaches cetain scroll value - translate the table header
      if ($('.tasks-table ').length) {
        // get distance of table to the top of the page
        const tableDistanceToTop = $('.tasks-table ').offset().top;

        const $tableHead = $('.tasks-table__head');

        // get the height of page header
        const headerHeight = $('.header').height();
        const $tableHeaderBg = $('.content-block__tasks-table-header-bg');

        // if page header moves past the table header - move table header down
        if (window.scrollY + headerHeight > tableDistanceToTop) {
          $tableHead.css('translate', `0 ${window.scrollY - tableDistanceToTop + headerHeight}px`);
          $tableHead.css('z-index', '2');
          $tableHeaderBg.show().css({
            translate: `0 ${window.scrollY - tableDistanceToTop + headerHeight}px`,
            height: $tableHead.height(),
          });
        } else {
          $tableHead.css('translate', '0 0');
          $tableHead.css('z-index', '0');
          $tableHeaderBg.hide();
        }
      }
    });

    // open priority popup on click
    $(document).on('click', '.task-priority__trigger', (e) => {
      const $target = $(e.target);
      const $el = $target.hasClass('task-priority__trigger')
        ? $target
        : $target.closest('.task-priority__trigger');
      $el.siblings('.task-priority__dropdown').toggleClass('task-priority__dropdown--open');
    });

    // close priority, assignee popup on outside click
    $('#tasks, #projects-tasks, #task-templates-edit').on('click', (e) => {
      $('.task-priority__dropdown').removeClass('task-priority__dropdown--open');
      $('.task-assignee__dropdown').removeClass('task-assignee__dropdown--open');
    });

    // update priority through priority popup selection
    $(document).on('click', '.task-priority__dropdown-option', (e) => {
      const $currentTarget = $(e.currentTarget);
      const taskId = $currentTarget
        .closest('.task-priority__dropdown')
        .siblings('.task-priority__trigger')
        .attr('data-task-id');
      const priority = $currentTarget.attr('data-priority');
      const data = {
        task: { priority },
        view_context: $viewContext,
        view_mode: $viewMode,
        sort: $sort,
      };

      if ($projectId) {
        data['project_id'] = $projectId;
      }

      $.ajax({
        url: `/tasks/${taskId}`,
        type: 'PATCH',
        data,
        success({ success, task_id: taskId, task_partial: taskPartial }) {
          if (success) {
            // Update the task row with the updated data
            if ($viewMode === 'grid' || $isMobile === 'true') {
              $(`tr[data-task-id="${taskId}"]`).replaceWith(taskPartial);
              initGridDatePicker();
              initTooltips($(`tr[data-task-id="${taskId}"]`).find('.tooltip'));
            } else {
              $(`.kanban-card[data-id="${taskId}"]`).replaceWith(taskPartial);
              initKanbanDatePickers();
              initKanbanDragableAndSortable();
              initTooltips($(`.kanban-card[data-id="${taskId}"]`).find('.tooltip'));
            }
            assignTasksStackingOrder();
          }
        },
      });
    });

    // open assignee dropdown
    $(document).on('click', '.task-assignee__trigger', (e) => {
      const $target = $(e.target);
      const $el = $target.hasClass('task-assignee__trigger')
        ? $target
        : $target.closest('.task-assignee__trigger');
      $el.siblings('.task-assignee__dropdown').toggleClass('task-assignee__dropdown--open');
    });

    // update assignee through assignee popup selection
    $(document).on('click', '.task-assignee__dropdown-option', (e) => {
      const $currentTarget = $(e.currentTarget);
      const currentUserId = $('meta[name="user-id"]').attr('content');
      const taskId = $currentTarget
        .closest('.task-assignee__dropdown')
        .siblings('.task-assignee__trigger')
        .attr('data-task-id');
      const assigneeId = $currentTarget.attr('data-assignee-id');
      const data = {
        task: { assignee_id: assigneeId, assigner_id: currentUserId },
        view_context: $viewContext,
        view_mode: $viewMode,
        sort: $sort,
      };

      if ($projectId) {
        data['project_id'] = $projectId;
      }

      // If modal is open, assignee update is for subtasks
      if ($('.task-form').length) {
        data['view_context'] = 'subtasks';
      }

      $.ajax({
        url: `/tasks/${taskId}`,
        type: 'PATCH',
        data,
        success({ success, task_id: taskId, task_partial: taskPartial }) {
          if (success) {
            // Update the task row with the updated data
            if ($('.task-form').length === 0) {
              if ($viewMode === 'grid') {
                $(`tr[data-task-id="${taskId}"]`).replaceWith(taskPartial);
                initGridDatePicker();
                initTooltips($(`tr[data-task-id="${taskId}"]`).find('.tooltip'));
              } else {
                $(`.kanban-card[data-id="${taskId}"]`).replaceWith(taskPartial);
                initKanbanDatePickers();
                initKanbanDragableAndSortable();
                initTooltips($(`.kanban-card[data-id="${taskId}"]`).find('.tooltip'));
              }
              assignTasksStackingOrder();
            } else {
              // Update subtask rows
              $(`.tasks-table-tr--edit-subtask[data-task-id="${taskId}"]`).remove();
              $(`.tasks-table-tr--subtask[data-task-id="${taskId}"]`).replaceWith(taskPartial);
              $('.tasks-table--subtasks .subtask-due-date__date-picker').each((_i, el) => {
                enableSubtaskDatePicker($(el));
              });
              initTooltips($('.tasks-table--subtasks').find('.tooltip'));
              assignTasksStackingOrder();
            }
          }
        },
      });
    });

    // when new inline kanban card clicked don't hide/submit new task
    $(document).on('mousedown', '.kanban-card--inline-form', (e) => {
      e.preventDefault();
    });

    // disable close icon when title is invalid
    $(document).on('keyup', '.field--task-title', (event) => {
      const $form = $(event.target).closest('.task-form');
      // the same flag ui--twin-turbo-modal#lock sets, without its focus move away from the title
      const $dialogHeader = $form
        .closest('dialog')
        .find('[data-ui--twin-turbo-modal-target="header"]');
      if (!event.target.value.trim()) {
        $form.find('.error-message--task-title').html('Task must have a title').show();
        $dialogHeader.attr('data-dismissible', 'false');
      } else {
        $form.find('.error-message--task-title').hide();
        $dialogHeader.attr('data-dismissible', 'true');
      }
    });
  });

  assignTasksStackingOrder();
});
